export enum AssetType {
    Call = 1,
    Put,
    Futures,
    Spot,
}
